import React from 'react';
import { connect } from 'react-redux';
import { openAddReclamationDialog } from 'store/common/commonActions';
import { openImportSouffranceDialog } from 'store/common/commonActions';
import AddReclamationButton from './AddReclamationButton';

import { GroupeTraitementCodes } from 'constants.js';


//import { addNotification, NotificationImportance } from 'store/common/commonActions';

class AddReclamationButtonContainer extends React.Component {
    handleClick = (actionName) => {
        const { openAddReclamationDialog, openImportSouffranceDialog } = this.props;

        if ('Import fichier souffrances transporteur' === actionName) {
            openImportSouffranceDialog();
        }
        else {
            openAddReclamationDialog(false, -1);
        }

    }

    render() {
        const { hidden, disabled, addReclamationDialogOpen, importSouffranceDialogOpen, lectureSeule, avecSouffrance } = this.props;


        if (addReclamationDialogOpen || importSouffranceDialogOpen || hidden || lectureSeule) {
            return null;
        }

        return (
            <AddReclamationButton
                disabled={disabled}
                onClick={this.handleClick}
                avecSouffrance={avecSouffrance}
            />
        );
    }
}

const mapStateToProps = (state) => {

    let lectureSeule = true;
    let avecSouffrance = false;

    let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

    if (utilisateurCourant) {
        lectureSeule = utilisateurCourant.lectureSeule;
        avecSouffrance = utilisateurCourant.groupes.find(groupe => groupe.code === GroupeTraitementCodes.ServiceTransport) !== undefined;
    }

    return {
        hidden: state.common.addReclamationButtonHidden,
        disabled: state.common.addReclamationButtonDisabled,
        addReclamationDialogOpen: state.common.addReclamationDialogOpen,
        importSouffranceDialogOpen: state.common.importSouffranceDialogOpen,
        lectureSeule: lectureSeule,
        avecSouffrance: avecSouffrance
    }
};


const mapDispatchToProps = dispatch => ({
    openAddReclamationDialog: (reclamationLiee, reclamationParentId) => dispatch(openAddReclamationDialog(reclamationLiee, reclamationParentId, null)),
    openImportSouffranceDialog: () => dispatch(openImportSouffranceDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(AddReclamationButtonContainer);